import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { getOpmInputsFromCapitalStructure } from '@app/core/inputs/getOpmInputsFromCapitalStructure';

export const useOpmInputsFromCapitalStructure = () => {
  const project = useAppSelector((state) => state.project.projectDraft);
  return getOpmInputsFromCapitalStructure(project);
};
